import { z } from "zod";
import { DocumentCurrencySchema } from "./documents";
import type { EventProfitLossDTO } from "./event-profit-loss";
import type { CurrencyAmountBuckets } from "./reports";

export type {
  EventProfitLossCostBreakdownDTO,
  EventProfitLossDTO,
  EventProfitLossSnapshotDTO,
} from "./event-profit-loss";

export const EventDetailReportDocumentTimelineItemSchema = z.object({
  id: z.string(),
  documentNo: z.string(),
  documentType: z.enum(["quotation", "invoice", "receipt"]),
  status: z.string(),
  currency: DocumentCurrencySchema,
  grandTotal: z.number(),
  paidAmount: z.number(),
  remainingAmount: z.number(),
  issuedAt: z.string().nullable(),
  createdAt: z.string(),
});

export type EventDetailReportDocumentTimelineItemDTO = z.infer<
  typeof EventDetailReportDocumentTimelineItemSchema
>;

export type EventDetailReportSameDayDiscountDTO = {
  applies: boolean;
  discountedShowCount: number;
  showCount: number;
  calendarDayCount: number;
};

export type EventDetailReportDTO = {
  eventId: string;
  eventTitle: string;
  assignmentCount: number;
  quoted: CurrencyAmountBuckets;
  invoiced: CurrencyAmountBuckets;
  collected: CurrencyAmountBuckets;
  outstandingAr: CurrencyAmountBuckets;
  payoutPaid: number;
  payoutOutstanding: number;
  margin: number | null;
  marginPercent: number | null;
  quotedVsActual: CurrencyAmountBuckets;
  quotedFulfillmentPercent: number | null;
  sameDayDiscount: EventDetailReportSameDayDiscountDTO;
  documents: EventDetailReportDocumentTimelineItemDTO[];
  profitLoss: EventProfitLossDTO;
};
